// extracted by css-extract-rspack-plugin
var _1 = "zs";
var _2 = "p6";
var _3 = "zw";
var _4 = "sq";
export { _1 as "formContainer", _2 as "loginRegistrationWrapperComponent", _3 as "lpVersionC", _4 as "textContent" }
